import { Link } from 'react-router-dom';
import { SEO } from '../components/SEO';
import { PageHero } from '../components/PageHero';
import { ScrollReveal } from '../components/ScrollReveal';
import { DarkTexture } from '../components/DarkTexture';
import { blogPosts } from '../data/blogPosts';
import { ArrowUpRight } from 'lucide-react';

const Blog = () => (
  <div className="bg-navy">
    <SEO
      title="DPDPA Privacy Blog — In-depth Articles on India's Data Law"
      description="Deep-dive articles on the DPDPA: the 18-month compliance roadmap, Section 6 consent, the 72-hour breach clock, Significant Data Fiduciary duties, Data Principal rights and children's data rules."
      path="/blog"
    />
    <PageHero
      testId="blog-page-hero"
      kicker="Privacy Blog"
      title="Everything on this blog stays on one subject"
      description="India's Digital Personal Data Protection Act — its rules, deadlines, interpretations and practice."
    />
    <section className="relative bg-navy py-16 sm:py-24 px-6 sm:px-10 lg:px-16 overflow-hidden" data-testid="blog-list-section">
      <DarkTexture orbs={false} />
      <div className="relative max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8">
        {blogPosts.map((post, i) => (
          <ScrollReveal key={post.slug} delay={(i % 2) * 0.1}>
            <Link to={`/blog/${post.slug}`} data-testid={`blog-list-card-${post.slug}`} className="block group bg-white/5 backdrop-blur-xl border border-white/10 rounded-xl p-6 hover:border-cyan/30 hover:-translate-y-1 transition-all duration-300 h-full">
              <p className="font-mono text-xs uppercase tracking-widest text-cyan mb-3">{post.tag} · {post.date}</p>
              <h2 className="font-serif text-2xl text-white mb-3 group-hover:text-cyan transition-colors leading-snug">{post.title}</h2>
              <p className="text-sm text-white/50 leading-relaxed mb-3">{post.excerpt}</p>
              <span className="text-sm text-white font-medium flex items-center gap-1">{post.readTime} · Read article <ArrowUpRight size={13} /></span>
            </Link>
          </ScrollReveal>
        ))}
      </div>
    </section>
  </div>
);

export default Blog;
